import { ColumnsType } from 'antd/lib/table';
import { Declaration } from 'store/declarations/declaration';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { GvmsReferenceData } from 'store/declarations/uk/gvms-declaration';
import { User } from 'store/session/user';
import getColumns, { ActionEvents } from '../DeclarationColumns';
import getGvmsColumns from '../GvmsColumns';
import { getIcs2Columns } from '../ics2Columns';
import { pickStandardActions } from './getStandardColumns';

interface Options {
    country: DeclarationCountry;
    type: DeclarationInternalType;
    actions: ActionEvents;
    user: User | undefined;
    declarations?: Declaration[];
    gvms: { referenceData?: GvmsReferenceData; canDelete: boolean; canArchive: boolean };
    ics2: { hasGroups: boolean; hasNotifications: boolean };
}

// Used inside /customs-declarations/{country}/{type}, where every row is of the same type, so the
// columns and the actions are the ones that type needs.
const getColumnsByDeclarationType = ({
    country,
    type,
    actions,
    user,
    declarations,
    gvms,
    ics2,
}: Options): ColumnsType<any> => {
    const { onDuplicate, onArchive, onUnarchive, onPrint, onDelete, onBarcode, onCoreTemplateToggle } = actions;

    switch (type) {
        case DeclarationInternalType.GVMS:
            return getGvmsColumns(
                gvms.referenceData,
                { onDuplicate, onArchive, onBarcode, onDelete, onCoreTemplateToggle },
                gvms.canDelete,
                gvms.canArchive
            );
        case DeclarationInternalType.PBN:
            return getColumns({ onArchive, onBarcode, onCoreTemplateToggle }, user, declarations);
        case DeclarationInternalType.ENS:
            return getIcs2Columns({ onDelete, onArchive, onUnarchive, groupActions: actions.groupActions }, user, ics2);
        default: {
            const isCdsExport = country === DeclarationCountry.UK && type === DeclarationInternalType.EXPORT;

            return getColumns(pickStandardActions(actions), user, declarations, {
                ducr: isCdsExport ? 'separate' : 'none',
            });
        }
    }
};

export default getColumnsByDeclarationType;
